import { frontendURL } from 'dashboard/helper/URLHelper';
import SettingsWrapper from 'dashboard/routes/dashboard/settings/SettingsWrapper.vue';
import PublicConversationSettings from './PublicConversationSettings.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/public-conversations'),
      meta: {
        permissions: ['administrator'],
      },
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_public_conversations',
          component: PublicConversationSettings,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
